<template>
    <div class="Download">
        <div class="content">
            <div class="content-center">
                <div class="content-left">
                    <h3>{{ $t('myAccount.text180') }}</h3>
                    <p class="pro">{{ $t('myAccount.text181') }}</p>
                    <div class="download-list">
                        <img @click="goto(1)"
                            src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/qr_mt4_windows%402x.png"
                            alt="">
                        <img @click="goto(2)"
                            src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/qr_mt4_macos%402x.png"
                            alt="">
                    </div>
                </div>
                <div class="content-right">
                    <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/img_appdownload%402x2.png"
                        alt="">
                </div>
            </div>
        </div>
        <div class="content content2">
            <div class="content-center">
                <div class="content-left">
                    <h3>{{ $t('myAccount.text182') }}</h3>
                    <p class="pro">{{ $t('myAccount.text181') }}</p>
                    <div class="download-list">
                        <img @click="goto(3)"
                            src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/qr_mt4_appstore%402x.png"
                            alt="">
                        <img @click="goto(4)"
                            src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/qr_mt4_android%402x.png"
                            alt="">
                    </div>
                </div>
                <div class="content-right">
                    <img src="https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/img_appdownload%402x.png"
                        alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Download',
    components: {
    },
    setup() {

        function goto(e) {
            switch (e) {
                case 1: window.location.href = 'https://daydaytrades.oss-cn-hongkong.aliyuncs.com/mt4download/mt4setup.exe';break;
                case 2: window.location.href = 'https://daydaytrades.oss-cn-hongkong.aliyuncs.com/mt4download/MetaTrader4.pkg.zip';break;
                case 3: window.location.href = 'https://apps.apple.com/us/app/metatrader-4/id496212596';break;
                case 4: window.location.href = 'https://inline.daydaytrades.com/static/apk/metatrader4.apk';break;
            }
        }
        return {
            goto
        }
    }
}
</script>

<style lang="less" scoped>
.Download {
    .content {
        background: url("https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/img_downloadbg_1%402x.png") no-repeat;
        height: 700px;
    }
    .content2{
        background: url("https://daydaytradesweb.oss-cn-hongkong.aliyuncs.com/my-account/img_downloadbg_2%402x.png") no-repeat;
    }
    .content-center {
        width: 1016px;
        margin: 0 auto;
        display: flex;
        padding-top: 120px;
        justify-content: space-between;

        .content-left {
            padding-top: 97px;
        }

        h3 {
            font-size: 36px;
            font-weight: bold;
        }

        .pro {
            margin-top: 27px;
            font-size: 16px;
            margin-bottom: 40px;
            font-weight: 500;
        }

        .download-list {
            img {
                width: 117px;
                height: 150px;
                cursor: pointer;
                &:not(:last-child) {
                    margin-right: 56px;
                }
            }
        }

        .content-right {
            img {
                width: 680px;
                height: 460px;
            }
        }
    }
}
</style>
